import React from "react";
import { graphql, PageProps, withPrefix, HeadFC } from "gatsby";
import Layout from "../../components/layout";
import CtaWidget from "../../components/sections/cta-widget";
import HeroHeader from "../../components/elements/hero-header";
import { useTranslation } from "gatsby-plugin-react-i18next";
import SEO from "../../components/seo";

const SocialCommercePage: React.FC<PageProps> = (props) => {
    const { t } = useTranslation();

    return (
        <Layout>
            <HeroHeader
                sectionId="banner-social"
                background={withPrefix("images/features/feat_banner_social.jpg")}
                webPBackground={withPrefix("images/webp/features/feat_banner_social.webp")}
                title={t("social.seo_title")}
                subtitle={t("social.slogan")}
                imgAlt={t("img-alt.features.feat_banner_social")}
            />
            <section id="article-social-1" className="sb-ga-click sb-ga-scroll py-3 py-md-6">
                <div className="container">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-lg-5 order-2 order-lg-1">
                            <div className="badge badge-soft-primary badge-pill font-weight-normal px-2 py-1 mb-3 text-primary ">{t("social.1_slogan")}</div>
                            <h2 className="font-weight-bold mb-4">{t("social.1_title")}</h2>
                            <p
                                className="text-muted mb-4"
                                dangerouslySetInnerHTML={{
                                    __html: t("social.1_content"),
                                }}
                            />
                        </div>
                        <div className="col-lg-6 text-center order-1 order-lg-2 mb-5 mb-lg-0">
                            <picture>
                                <source srcSet={withPrefix(t("social.1_webp"))} className="img-fluid" type="image/webp" />
                                <source srcSet={withPrefix(t("social.1_png"))} className="img-fluid" type="image/jpeg" />
                                <img alt={t("img-alt.features.social-commerce.social-1")} className="img-fluid" src={withPrefix("images/features/social-commerce/social-1-en.png")} />
                            </picture>
                        </div>
                    </div>
                </div>
            </section>

            <div className="text-light-primary mt-n1 mt-sm-0">
                <svg preserveAspectRatio="none" viewBox="0 0 2000 150" xmlns="http://www.w3.org/2000/svg">
                    <polygon fill="currentColor" points="0 0 2000 150 0 150"></polygon>
                </svg>
            </div>
            <section id="article-social-2" className="sb-ga-click sb-ga-scroll  py-6 bg-light-primary">
                <div className="container">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-lg-6 order-1 order-lg-1 mb-5 mb-lg-0 ">
                            <picture>
                                <source srcSet={withPrefix(t("social.2_webp"))} className="img-fluid" type="image/webp" />
                                <source srcSet={withPrefix(t("social.2_png"))} className="img-fluid" type="image/jpeg" />
                                <img alt={t("img-alt.features.social-commerce.social-2")} className="img-fluid" src={withPrefix("images/features/social-commerce/social-2-en.png")} />
                            </picture>
                        </div>
                        <div className="col-lg-5 order-2 order-lg-2">
                            <div className="badge badge-soft-primary badge-pill font-weight-normal px-2 py-1 mb-3 text-primary ">{t("social.2_slogan")}</div>
                            <h2 className="font-weight-bold mb-4">{t("social.2_title")}</h2>
                            <p
                                className="text-muted mb-4"
                                dangerouslySetInnerHTML={{
                                    __html: t("social.2_content"),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <div className="text-light-primary mt-n1 mt-sm-0">
                <svg preserveAspectRatio="none" viewBox="0 0 2000 150" xmlns="http://www.w3.org/2000/svg">
                    <polygon fill="currentColor" points="0 0 2000 0 2000 150"></polygon>
                </svg>
            </div>

            <section id="article-social-3" className="sb-ga-click sb-ga-scroll py-3 py-md-6">
                <div className="container">
                    <div className="row justify-content-between align-items-center">
                        <div className="col-lg-6 order-1 order-lg-2 mb-5 mb-lg-0 ">
                            <picture>
                                <source srcSet={withPrefix(t("social.3_webp"))} className="img-fluid" type="image/webp" />
                                <source srcSet={withPrefix(t("social.3_png"))} className="img-fluid" type="image/jpeg" />
                                <img alt={t("img-alt.features.social-commerce.social-3")} className="img-fluid" src={withPrefix("images/features/social-commerce/social-3-en.png")} />
                            </picture>
                        </div>
                        <div className="col-lg-5 order-2 order-lg-1">
                            <div className="badge badge-soft-primary badge-pill font-weight-normal px-2 py-1 mb-3 text-primary ">{t("social.3_slogan")}</div>
                            <h2 className="font-weight-bold mb-4">{t("social.3_title")}</h2>
                            <p
                                className="text-muted mb-4"
                                dangerouslySetInnerHTML={{
                                    __html: t("social.3_content"),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <CtaWidget {...props} />
        </Layout>
    );
};

export default SocialCommercePage;

export const Head: HeadFC<{}, { language: string }> = ({ pageContext }) => <SEO locale={pageContext.language} title="seo.features.social-commerce.title" keywords="seo.features.social-commerce.keywords" description="seo.features.social-commerce.description"></SEO>;

export const query = graphql`
    query ($language: String!) {
        locales: allLocale(filter: { language: { eq: $language } }) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`;
